import { useContext, useEffect, useState } from "react";
import { ConversionSourceContext } from "src/context/ConversionSourceContext";
import { GrowthbookClientContext, GrowthbookClientProps } from "src/context/GrowthbookClientContext";
import getTrackingMetadata from "src/helpers/event-tracking/getTrackingMetadata";
import { KoalaAttribute } from "src/types/koala/KoalaCart";

export default function useCartAttributes() {
  const { visitorId } = useContext(GrowthbookClientContext);
  const { conversionSources, referrerUrl } = useContext(ConversionSourceContext);
  const [attributes, setAttributes] = useState<KoalaAttribute[]>([]);

  useEffect(
    function () {
      setAttributes([
        { name: "mixpanelUserId", value: visitorId },
        { name: "trackingMetadata", value: JSON.stringify(getTrackingMetadata()) },
        { name: "conversion_sources", value: conversionSources.join(",") },
        { name: "referrer_url", value: referrerUrl },
      ]);
    },
    [visitorId, conversionSources.join(","), referrerUrl]
  );

  return attributes;
}
